<template>
    <div class="modal-component">
        <Transition name="modal-fade">
            <div v-if="isOpen" class="modal-component__overlay" @click="closeModal">
                <div class="modal-component__container">
                    <button class="modal-component__close" @click="closeModal" aria-label="Close modal">
                    <span class="modal-component__close-icon">&times;</span>
                    </button>
                    <slot></slot>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup>
    import { ref, onMounted, onBeforeUnmount, TransitionGroup, Transition } from 'vue';

    const props = defineProps({
        id: {
            type: String,
            required: true,
            default: 'general'
        }
    });

    const emit = defineEmits(['modal-opened', 'modal-closed']);

    const isOpen = ref(false);

    function openModal() {
        isOpen.value = true;
        document.body.style.overflow = 'hidden';
        emit('modal-opened', );
    }
    
    function closeModal() {
        isOpen.value = false;
        document.body.style.overflow = '';
        emit('modal-closed');
    }

    function handleOpenEvent(event) {
        if (event.detail?.id === props.id && !isOpen.value) {
            openModal();
        }
    }

    function handleEscape(event) {
        if (event.key === 'Escape' && isOpen.value) {
            closeModal();
        }
    }

    onMounted(() => {
        // Listen for custom event to open modal
        window.addEventListener('open-modal', handleOpenEvent);
        // Close on escape key
        document.addEventListener('keydown', handleEscape);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('open-modal', openModal);
        document.removeEventListener('keydown', handleEscape);
    });
</script>

<style scoped>
    .modal-component__close-icon {
        color: #1D2243;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity 0.3s ease;
    }

    .modal-fade-enter-from,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active .modal-component__container,
    .modal-fade-leave-active .modal-component__container {
        transition: transform 0.3s ease;
    }

    .modal-fade-enter-from .modal-component__container,
    .modal-fade-leave-to .modal-component__container {
        transform: scale(0.6);
    }
</style>